import { render, staticRenderFns } from "./MicroPopup.vue?vue&type=template&id=b30f1564&"
import script from "./MicroPopup.vue?vue&type=script&lang=js&"
export * from "./MicroPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports